<template>
    <!-- Layout inner -->
    <div class="layout-inner pg_content course_about prog_intro">
      <!-- Layout navbar -->
      <navbar></navbar>

      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>

          <template v-if="showPage && !showLoader">

            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">

              <div class="row">
                <div class="col-12 thumbnail_container thumbnail_container_large">
                  <div class="thumbnail_container_inner">
                    <img class="thumb_img"
                      v-if="programGuide.thumbnailURL"
                      :src="programGuide.thumbnailURL"
                      tabindex="0"
                      onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                    <div v-else class="default_thumb">
                      <span class="ic ic-degreeProgram"></span>
                    </div>
                  </div>
                </div>

                <template v-if="!programGuide.pragyaProgram && enrollmentEnabled">
                  <div class="col-12 program_status_select_bx">
                    <div class="selected_val">
                      <div class="val not_enrolled" v-if="enrollmentStatus === 'NOTENROLLED'">Not Enrolled</div>
                      <div class="val in_progress" v-if="enrollmentStatus === 'INPROGRSS'">In Progress</div>
                      <div class="val completed" v-if="enrollmentStatus === 'COMPLETED'">Completed</div>
                      <div class="val not_complete" v-if="enrollmentStatus === 'NOTCOMPLETED'">Couldn't Complete</div>
                      <div class="ic ic22-dropdown2"></div>
                    </div>
                    <div class="select_bx">
                      <select class="form-control" v-model="enrollmentStatus" @change="changeEnrollmentStatus">
                        <option value="NOTENROLLED" selected>Not Enrolled</option>
                        <option class="" value="INPROGRSS">In Progress</option>
                        <option class="" value="COMPLETED">Completed</option>
                        <option class="" value="NOTCOMPLETED">Couldn't Complete</option>
                      </select>
                    </div>
                  </div>
                </template>
                <template v-if="!programGuide.pragyaProgram && !enrollmentEnabled && programGuide.additionalProgramDetail">
                  <div class="row result_row price_plan_sec pragya_program_detail_sec" style="padding-bottom: 1px;">
                    <template v-if="programGuide.cost">
                      <div class="col-12 price">
                        <span>Cost </span>
                        <span class="val">${{programGuide.cost}}</span>
                      </div>
                    </template>
                    <div class="col-12 btn_container">
                        <b-btn @click="navigateToRequirements" >
                          <span class="btn_txt">Learn More</span>
                        </b-btn>
                    </div>
                    <div class="col-12 filter_tags_containter">
                       <span class="filter_tag" v-if="programGuide.modalityType"> {{getModalityValue(programGuide.modalityType)}} </span>
                       <span class="filter_tag"  v-if="programGuide.fundingType"> {{getFundingValue(programGuide.fundingType)}}</span>
                    </div>
                    <div class="col-12 lnk_container" v-if="programGuide.faqGroup && programGuide.faqGroup.faqGroups && programGuide.faqGroup.faqGroups.length > 0">
                      <a href="javascript:void(0);" @click="navigateToFAQView">more</a>
                    </div>
                  </div>
                </template>

              </div>

              <div class="row sec_sep" v-if="!programGuide.pragyaProgram && enrollmentEnabled" >
                <div class="col-12"></div>
              </div>

              <div class="row result_row" v-if="showCareerProspectsTab && !programGuide.disableLMI">
                <div class="col-12 entity_details career_data_sec">
                  <div class="row mt-2">
                    <!--
                    <div class="col-2 national_data_ic">
                      <div class="bx_graphics">
                        <div class="ic ic22-UsMap"></div>
                        <div class="txt">National</div>
                      </div>
                    </div>
                    -->
                    <template v-if="showAlumniDataJobTitle">
                      <div class="col-12 sec_hd">
                        <div class="hd_txt">{{alumniData.topCareerTitle}}</div>
                        <div class="hd_info">most popular alumni career</div>
                      </div>
                    </template>
                    <div class="col-10" style="margin: auto;">
                      <div class="row">
                        <template v-if="!showAlumniDataJobTitle">
                          <div class="col-6 sec_hd">
                            <span
                              class="hd_txt"
                              style="width: 100%; text-align: center; display: block;">
                              US Data
                            </span>
                          </div>
                        </template>
                        <template v-if="showMedianIncome">
                          <div class="col-6 sec_data">
                            <div class="val" v-if="programGuide.medianIncomePerYear">
                              {{currencyLabel}} <span v-html="addCommaInNumber(programGuide.medianIncomePerYear)"></span>
                            </div>
                            <div class="val no_data" v-else>N/A</div>
                            <div class="label">{{medianIncomeLabel}}</div>
                          </div>
                        </template>
                        <template v-if="showJobPostings">
                          <div class="col-6 sec_data">
                            <div class="val" v-if="programGuide.totalJobPostings">
                              <span v-html="addCommaInNumber(programGuide.totalJobPostings)"></span>
                            </div>
                            <div class="val no_data" v-else>N/A</div>
                            <div class="label">{{jobPostingsLabel}}</div>
                          </div>
                        </template>
                        <template v-if="showGrowthRate">
                          <div class="col-6 sec_data">
                            <div class="val" v-if="programGuide.growthRate">
                              <span v-html="formatNumericVal(programGuide.growthRate)"></span>%
                            </div>
                            <div class="val no_data" v-else>N/A</div>
                            <div class="label">{{growthRateLabel}}<span class="exclamation-circle" v-popover:tooltip="'Source: BLS. 2016-2026'"><span class="ico-error"></span></span></div>
                          </div>
                        </template>
                        <template v-if="showAlumniDataJobTitle">
                          <div class="col-6 sec_data lnk_container">
                            <a href="javascript:void(0);" @click="navigateToCareerProspects">more</a>
                          </div>
                        </template>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="row sec_sep" style="margin-top: 0px;">
                <div class="col-12"> </div>
              </div>

              <!-- Program Status -->
              <template v-if="enrollmentEnabled">
                <div class="row result_row price_plan_sec" v-if="showEnrollment" style="padding-bottom: 1px;">
                  <template v-if="programGuide.pragyaProgram">
                    <template>
                      <div class="col-12">
                        <template v-if="enrollmentStatus === 'NOTENROLLED' || !transactionValidity.transactionValid" >
                          <template v-if="isPricingAvailable || programGuide.freeProgram">
                            <div class="row sec_row mt-1">
                              <div class="col-9 sec_hd">
                                <div class="hd_txt">Get Started Now</div>
                              </div>
                            </div>
                            </template>
                            <template v-if="isPricingAvailable && !transactionValidity.includedWithSubscription">
                            <div class="row sec_row">
    													<div class="col-12 price">
    														<span v-if="programGuide.pricingPlans.length > 1">Starting at </span>
                                <span v-if="programGuide.pricingPlans.length === 1 && !transactionValidity.includedWithSubscription">Price is </span>
    														<span class="val">{{minPrice}}</span>
    													</div>
    												</div>
                          </template>
                          <template v-else-if="isPricingAvailable && transactionValidity.includedWithSubscription">
                            <div class="row sec_row">
                              <div class="col-12 price">
                                <span> included in the suscription plan</span>
                              </div>
                            </div>
                          </template>

                          <template v-else-if="programGuide.cost">
                            <div class="row sec_row">
                              <div class="col-12 price">
                                <span>Cost </span>
                                <span class="val">${{programGuide.cost}}</span>
                              </div>
                            </div>
                          </template>

                          <template v-if="!isPricingAvailable && !programGuide.freeProgram && !programGuide.paymentProcessedOutOfPragya">
                            <div class="btn_container">
                                      <b-btn>
                                        <span class="btn_txt">Coming Soon</span>
                                      </b-btn>
                            </div>

                          </template>
                        </template>
                        <template v-if="enrollmentStatus !== 'NOTENROLLED' && transactionValidity.transactionValid">
                          <h5>My Progress</h5>
                        </template>
                      </div>
                    </template>
                    <div class="col-12 btn_container">
                      <div v-if="enrollmentStatus === 'NOTENROLLED' || !transactionValidity.transactionValid" class="subscribe_btn_container">
                        <template v-if="!programGuide.freeProgram">
                          <template v-if="!showLoader && programGuide.paymentProcessedOutOfPragya">
                            <div class="price_plan_sec">
                            <div class="row sec_row">
                              <div class="col-12 app_plan_status">
                                <div class="btn_container" v-if="Object.keys(userSISProgramMapping).length === 0">
                                  <b-btn @click.stop.prevent="createApplication">
                                    <span class="btn_txt"> Apply </span>
                                  </b-btn>
                                </div>
                                <template v-if="Object.keys(userSISProgramMapping).length > 0">
                                  <template v-if="userSISProgramMapping.status === 'IN_PROGRESS'">
                                    <div class="status_info">
                                      <span class="txt"> Application In Progress </span>
                                    </div>
                                    <div class="btn_container">
                                      <b-btn @click.stop.prevent="resendApplicationLink">
                                        <span class="btn_txt"> Re-send application link</span>
                                      </b-btn>
                                    </div>
                                  </template>
                                  <template v-if="userSISProgramMapping.status === 'SUBMITTED' || userSISProgramMapping.status === 'PENDING_DECISION'">
                                    <div class="ic_container">
        															<span class="ic ic22-hour-glass"></span>
        														</div>
                                    <div class="status_info">
                                      <span class="txt">Decision Pending</span>
                                    </div>
                                  </template>
                                  <template v-if="userSISProgramMapping.status === 'ACCEPTED' && userSISProgramMapping.feeStatus === 'UNPAID'">
                                    <div class="status_info">
                                      <span class="txt">Application Approved</span>
                                    </div>
                                    <div class="btn_container">
                                      <b-btn :href="paymentUrl" target="_blank">
                                        <span class="btn_txt">Make Payment</span>
                                      </b-btn>
                                    </div>
                                  </template>
                                  <template v-if="userSISProgramMapping.status === 'ACCEPTED' && (userSISProgramMapping.feeStatus === 'PAID' || userSISProgramMapping.feeStatus === 'WAIVED')">
                                    <div class="ic_container">
        															<span class="ic ic22-hour-glass"></span>
        														</div>
                                    <div class="status_info">
                                      <span class="txt">Enrollment Pending</span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </div>
                          </div>
                          </template>
                          <template v-if="!showLoader && !programGuide.paymentProcessedOutOfPragya && isPricingAvailable">
                          <template v-if="transactionValidity.transactionValid">
                            <b-btn @click.stop.prevent="confirmProgramSubscription">
                    					<span class="btn_txt"> Start </span>
                    				</b-btn>
                          </template>
                          <template v-else>
                            <b-btn @click.stop.prevent="showBuyFlow">
                              <span class="btn_txt"> Buy </span>
                            </b-btn>
                          </template>

                          </template>
                          <template v-if="showLoader">
                            <span class="text-black">Loading..</span>
                          </template>
                        </template>
                        <template v-if="programGuide.freeProgram">
                          <b-btn @click.stop.prevent="confirmProgramSubscription">
                  					<span class="btn_txt"> Start </span>
                  				</b-btn>
                        </template>
                      </div>
                      <div v-if="enrollmentStatus !== 'NOTENROLLED' && transactionValidity.transactionValid">
                        <div class="selected_val">
                          <div class="val in_progress" style="padding: 6px 8px;">In Progress</div>
                        </div>
                      </div>
                    </div>
                   <div class="col-12">
                       <span class="filter_tag" v-if="programGuide.modalityType"> {{getModalityValue(programGuide.modalityType)}} </span>
                       <span class="filter_tag"  v-if="programGuide.fundingType"> {{getFundingValue(programGuide.fundingType)}}</span>
                    </div>

                    <div class="lnk_container" v-if="programGuide.faqGroup && programGuide.faqGroup.faqGroups && programGuide.faqGroup.faqGroups.length > 0">
                      <a href="javascript:void(0);" @click="navigateToFAQView">more</a>
                    </div>


                    <div v-if="enrollmentStatus !== 'NOTENROLLED' && !transactionValidity.transactionValid" class="row alert_msg_sec">
                      <div class="col-12 msg_container" v-html="transactionValidity.institutionPurchaseExpirationMessage">
                      </div>
                    </div>

                  </template>

                </div>
              </template>

              <div class="row sec_sep" v-if="enrollmentEnabled">
                <div class="col-12"></div>
              </div>

              <div class="row" v-if="programGuide.credentialList.length>0">
                <div class="col-12 pg_sec_head mt-0 mb-2 p-0">
                  <h3 class="ace_sec_hd hd_txt m-0">Credentials</h3>
                </div>
                <div class="col-12">
                  <div class="row list_container credential_list">
                    <div class="col-12 list_row" v-for="credential in programGuide.credentialList">
                      <div class="row">
                        <div class="col-3 thumbnail">
                          <template v-if="credential.icon">
                            <img v-bind:src="credential.icon"
                              alt="Img"
                              class="thumb_img">
                            </template>
                            <template v-else>
                              <div class="default_thumb">
                                <span class="ic ic24-credential"></span>
                              </div>
                            </template>
                        </div>
                        <div class="col-9 txt_bx d-flex align-items-center">
                          {{credential.title}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 lnk_container">
                      <a href="javascript://" v-if="showFAQTab" @click="navigateToFAQView">more</a>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row sec_sep" v-if="programGuide.credentialList.length>0">
                <div class="col-12"></div>
              </div>

              <div class="row menu_container">
                <div class="entity_menu_bx" v-if="showIntroductionTab" @click="navigateToIntro">
                  <div class="ic_container">
                    <span class="ic ic-home3"></span>
                  </div>
                  <div class="title">{{introductionTabLabel}}</div>
                </div>
                <div class="entity_menu_bx" v-if="showCareerProspectsTab && !programGuide.disableLMI" @click="navigateToCareerProspects">
                  <div class="ic_container">
                    <span class="ic ic-careerProgress"></span>
                  </div>
                  <div class="title">{{careerProspectsTabLabel}}</div>
                </div>
                <div class="entity_menu_bx" v-if="showStreamsTab" @click="navigateToPathways">
                  <div class="ic_container">
                    <span class="ic ic-stream"></span>
                  </div>
                  <div class="title">{{streamsTabLabel}}</div>
                </div>
                <!--
                <div class="entity_menu_bx" v-if="showCareersTab" @click="navigateToCareers">
                  <div class="ic_container">
                    <span class="ic ic-career"></span>
                  </div>
                  <div class="title">{{careersTabLabel}}</div>
                </div>
                -->
                <div class="entity_menu_bx" v-if="showAlumniInsightsTab" @click="navigateToAlumniInsights">
                  <div class="ic_container">
                    <span class="ic ic-alumniInsights"></span>
                  </div>
                  <div class="title">{{alumniInsightsTabLabel}}</div>
                </div>
                <div class="entity_menu_bx" v-if="showDegreeRequirementsTab" @click="navigateToRequirements">
                  <div class="ic_container">
                    <span class="ic ic-degree"></span>
                  </div>
                  <div class="title">{{degreeRequirementsTabLabel}}</div>
                </div>
                <div class="entity_menu_bx"  v-if="showConcentrationTab" @click="navigateToConcentrations">
                  <div class="ic_container">
                    <span class="ic ic-degree"></span>
                  </div>
                  <div class="title">Concentrations</div>
                </div>
                <div class="entity_menu_bx" v-if="showRelatedProgramTab" @click="navigateToRelatedPrograms">
                  <div class="ic_container">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                  <div class="title">{{relatedProgramsTabLabel}}</div>
                </div>
                <div class="entity_menu_bx" v-if="showMyProgramStatusTab" @click="navigateToMyProgramStatus">
                  <div class="ic_container">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                  <div class="title">My Progress</div>
                </div>
                <div class="entity_menu_bx" v-if="showAlumniTab" @click="navigateToSpotlightAlumniView">
                  <div class="ic_container">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                  <div class="title">Alumni</div>
                </div>
                <div class="entity_menu_bx" v-if="showFAQTab" @click="navigateToFAQView">
                  <div class="ic_container">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                  <div class="title">{{FAQTabLabel}}</div>
                </div>
                <div class="entity_menu_bx" v-if="showComplianceTab" @click="navigateToComplianceView">
                  <div class="ic_container">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                  <div class="title">{{complianceTabLabel}}</div>
                </div>

                <!--
                <div class="entity_menu_bx">
                  <div class="ic_container">
                    <span class="ic"></span>
                  </div>
                  <div class="title"></div>
                </div>
                -->
            </div>

            </div>
            <!-- / Page content -->

            <!-- Buy Flow Modal -->
            <div>
              <b-modal class="subscribe_modal modal__v22_2 price_plan_modal" id="buy-modal-popup" ref="buyModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

        				<div slot="modal-header" class="w-100">
        					<div class="row">
        						<div class="col-1 ic_container">
        							<span class="ic ic22-buy"></span>
        						</div>
        	          <div class="col-10 hd_txt">
                      <span v-if="showPlansPage">Buying - Registration Details</span>
                      <span v-if="showSummaryPage">Buying - Payment Details</span>
                      <span v-if="showSuccessPage">Buying - Success!</span>
        	          </div>
        	          <div class="col-1 close_btn_container">
        	            <button class="btn_close" aria-label="close" title="close the popup" @click="closeBuyModal">
        	              <span class="ic-close"></span>
        	            </button>
        	          </div>
        					</div>
        				</div>

                  <div class="row content_container" style="position: static;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form_section" style="position: static;">
                      <template v-if="showPlansPage">

        								<div class="btn_container action_bar">
        									<b-btn @click.stop.prevent="moveToSummaryPage">
        										<span class="btn_txt">next</span>
        									</b-btn>
        								</div>


                        <div class="row sub_hd">
        									<div class="col-12 hd_txt">
        										<div class="">Buying {{programGuide.title}}</div>
        									</div>
        								</div>
                        <div class="col-12">
  												<div class="row sec_row sec_sub_hd" v-if="oneTimePlans.length > 0">
  		                      One Time Plans
  		                    </div>
  												<div v-if="oneTimePlans.length > 0" class="row sec_row" v-for="pricingPlan in oneTimePlans">
  													<div class="col-1 fld_radio">
  														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
  													</div>
  													<div class="col-10">
  														{{pricingPlan.name}} - ${{pricingPlan.price}}
  													</div>
  												</div>
  											</div>

  											<div class="col-12">
  												<div class="row sec_row sec_sub_hd" v-if="subscriptionPlans.length > 0">
  		                      Subscription Plans
  		                    </div>
  												<div v-if="subscriptionPlans.length > 0" class="row sec_row" v-for="pricingPlan in subscriptionPlans">
  													<div class="col-1 fld_radio">
  														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
  													</div>
  													<div class="col-10">
  														{{pricingPlan.name}} - ${{pricingPlan.price}}
                              <span v-if="pricingPlan.type === 'subscription-monthly'">/month</span>
                              <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
  		                        <span v-if="pricingPlan.type === 'subscription-yearly'">/year</span>
  													</div>
  												</div>
  											</div>


        								<div class="row sub_hd student_info">
        									<div class="col-12 hd_txt">
        										<div class="">Student Information</div>
        									</div>
        								</div>

        								<div class="row">
        									<div class="col-12 sec_content">

        										<div class="row fld_row">
        											<div class="col-12 fld_label">
        												 First Name*
        											 </div>
        											 <div class="col-12 fld_val">
        												 <input
        		                       type="text"
        		                       class="lms-course-field"
        		                       placeholder="First Name"
        		                       :value="firstName"
        		                       disabled
        		                       >
        										  </div>
        										</div>

        										<div class="row fld_row">
        											<div class="col-12 fld_label">
        												 Last Name*
        											 </div>
        											 <div class="col-12 fld_val">
        												 <input
        	                         type="text"
        	                         class="lms-course-field"
        	                         placeholder="Last Name"
        	                         :value="lastName"
        	                         disabled
        	                         >
        										  </div>
        										</div>

        										<div class="row fld_row">
        											<div class="col-12 fld_label">
        												 Email*
        											 </div>
        											 <div class="col-12 fld_val">
        												 <input
        		                       type="text"
        		                       class="lms-course-field"
        		                       placeholder="Email"
        		                       disabled
        		                       :value="email"
        		                       >
        										  </div>
        										</div>

        									</div>
        								</div>
                      </template>
                      <template v-if="showSummaryPage">
                        <template v-if="!showStripeSetupError">

        									<template v-if="showPaymentLoader">
                            <p>Loading</p>
                          </template>

                          <template v-if="!showPaymentLoader">
        										<div class="btn_container">
        											<b-btn @click.stop.prevent="moveToPlansPage">
        	                      <span class="btn_txt">prev</span>
        	                    </b-btn>
        	                    <b-btn @click.stop.prevent="moveToSuccessPage">
        												<!--
        	                      <span class="btn_txt"> Submit & Register </span>
        												-->
        												<span class="btn_txt"> submit & register </span>
        	                    </b-btn>
        										</div>
        									</template>

        									<div class="row sub_hd">
        										<div class="col-12 hd_txt">
        											<div class="">Order Summary</div>
        										</div>
        									</div>
        									<div class="row">
        										<div class="col-12 sec_content order_summary">
                              <div class="row sec_row">
        												<div class="col-12 plan">
        													{{programGuide.title}}
        												</div>
        											</div>
        											<div class="row sec_row">
        												<div class="col-8 plan">
        													{{selectedPricingPlan.name}}
        												</div>
        												<div class="col-4 price">
        													${{selectedPricingPlan.price}}
                                  <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>
                                  <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                                  <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
        												</div>
        											</div>

                              <div class="row sec_row">
        												<div class="col-12">
                                  <div class="row fld_row">
            												 <div class="col-8 fld_val">
            													 <input
            		                         type="text"
            		                         class="lms-course-field"
            		                         placeholder="enter discount coupon code"
            		                         v-model="coupon"
            		                         >
                                       </div>
                                        <div class="col-4 btn_container" style="padding-top: 6px;">
                                          <b-btn @click.stop.prevent="applyCoupon">
                                           <span class="btn_txt">apply</span>
                                          </b-btn>
                                        </div>

                                    <div class="col-12 fld_label text-red" v-if="showCouponError">
                                      Coupon is invalid. Try another one.
            												 </div>
            											</div>
                                </div>
                              </div>

                              <div class="row sec_row" v-if="couponObj && couponObj.code ">
        												<div class="col-7 coupon_code">
        													{{couponObj.code}}
                                  <b-btn class="btn ic_btn btn_trans btn-secondary" @click.stop.prevent="removeCoupon">
                                   <span class="ic ic8-bin2"></span>
                                 </b-btn>
        												</div>
        												<div class="col-5 coupon_price price">
        													 - ${{discountPrice}}
        												</div>
        											</div>


        											<div class="row sec_row total">
        												<div class="col-6 plan">
        													Total
        												</div>
        												<div class="col-6 price">
        													${{finalPrice}}
                                  <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>
                                  <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                                  <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
        												</div>
        											</div>

        										</div>
        									</div>

                          <template v-if="finalPrice > 0">
          									<div class="row sub_hd">
          										<div class="col-12 hd_txt">
          											<div class="">Payment</div>
          										</div>
          									</div>
                            <template v-if="selectedPricingPlan.type !== 'onetime' && paymentMethodsToShow.length > 0 ">
                              <div class="row payment">
                                <div class="col-12 sec_content existing_ac_lst">
                                  <div class="row fld_row">
                                    <div class="col-12 fld_label">
                                      Use an Existing Pay
                                    </div>
                                    <div class="col-12 row" v-for="userPaymentMethod in paymentMethodsToShow">
                                      <div class="col-1 fld_radio">
            														<input type="radio" name="plan" :value="userPaymentMethod" v-model="selectedPaymentMethod">
            													</div>
                                      <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2 sec_row">
                                        <div class="card__number info_val2">
                                          <span class="info_title2 no_val">****</span>
                                          <span class="info_val2">{{userPaymentMethod.lastFour}}</span>
                                        </div>
                                      </div>
                                      <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2 sec_row">
                                        <div class="expiry_date">
                                          <span class="info_title2">expiry:</span>
                                          <span class="info_val2">{{userPaymentMethod.expiration}}</span>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <div class="row payment">
                                <div class="col-12 sec_content">
                                  <div class="row fld_row">
                                    <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid === ''">
                                      Or
                                    </div>
                                    <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid !== ''">
                                      <b-btn @click.stop.prevent="clearAndAddNewPayment">
                                        <span class="btn_txt">Add new card instead</span>
                                      </b-btn>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
          									<div class="row payment" v-if="selectedPaymentMethod.uuid === ''">
          										<div class="col-12 sec_content">
          											<div class="row fld_row">
          												<div class="col-12 fld_label">
          													Credit Card Details
          												</div>
          												<div class="col-12">
          													<div ref="card" id="card-element"></div>
          												</div>
          											</div>
          										</div>
          									</div>


          									<div class="row sub_hd">
          										<div class="col-12 hd_txt">
          											<div class="">Billing Information</div>
          										</div>
          									</div>
          									<div class="row">
          										<div class="col-12 sec_content">

          											<div class="row sec_row">
          												<div class="col-12 mb-2">
          													<input
                                			style="width:10%!important;"
                                  		type="checkbox"
                                  		class="lms-course-field"
                                  		v-model="sameAsStudent"
                                  	> same as student information
          												</div>
          											</div>

          											<div class="row fld_row">
          												<div class="col-12 fld_label">
          													 First Name*
          												 </div>
          												 <div class="col-12 fld_val">
          													 <input
          		                         type="text"
          		                         class="lms-course-field"
          		                         placeholder="First Name"
          		                         v-model="billingFirstName"
          		                         >
          											  </div>
          											</div>

          											<div class="row fld_row">
          												<div class="col-12 fld_label">
          													 Last Name*
          												 </div>
          												 <div class="col-12 fld_val">
          													 <input
          	                           type="text"
          	                           class="lms-course-field"
          	                           placeholder="Last Name"
          	                           v-model="billingLastName"
          	                           >
          											  </div>
          											</div>

          											<div class="row fld_row">
          												<div class="col-12 fld_msg">
          													<p v-if="showMissingBillingInfoError" class="text-red">First Name & Last Name are required.</p>
          													<p v-if="showPaymentFailureError" class="text-red">Payment Failed. Please try again.</p>
          												</div>
          											</div>

          										</div>
          									</div>
                          </template>
        								</template>
                        <template v-if="showStripeSetupError">
        									<div class="row sub_hd mt-3">
        										<div class="col-12 hd_txt">
        											<div class=""></div>
        										</div>
        									</div>
        									<div class="row mb-5">
        										<div class="col-12">
        											<div class="row sec_row">
        												<div class="col-12">
        													There was error in setup. Please reach out to
        													<a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
        												</div>
        											</div>
        										</div>
        									</div>
                        </template>
                      </template>
                      <template v-if="showSuccessPage">
        								<div class="row mb-5">
        									<div class="col-12">
        										<div class="row sec_row">
        											<div class="col-12">
        												Congratulations! You have successfully enrolled in {{programGuide.title}}. Get started now!
        											</div>
        										</div>

        										<div class="row sec_row">
        											<div class="col-12 btn_container2">
        												<a class="btn" @click="redirectToLearnerDashboard">Go to Home Page</a>
        											</div>
        										</div>
        									</div>
        								</div>

        							</template>
                    </div>
        	  			</div>

              </b-modal>
            </div>
            <!-- Buy Flow Modal Ends -->

            <!-- Price Plan Detials Modal -->
        		<div>
        			<b-modal id="pricePlanDetails" ref="pricePlanDetailsModal" class="subscribe_modal modal__v22_2 price_plan_modal price_plan_details_modal" :header-bg-variant="'credential-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

        				<div slot="modal-header" class="w-100">
        					<div class="row">
        						<div class="col-10 hd">
        							<div class="ic_container">
        								<span class="ic ic22-buy"></span>
        							</div>
        							<div class="hd_txt">
        								<span>Pricing Plan for {{programGuide.title}}</span>
        							</div>
        						</div>
        						<div class="col-2 btn_container">
        							<button class="btn_close" aria-label="close" title="close the popup" @click="closePricePlanDetailsModal">
        								<span class="ic-close"></span>
        							</button>
        						</div>
        					</div>
        				</div>

                <div class="row content_container" style="max-width: 100%;">
        					<div class="col-12">
                    <div class="row">
                      One Time Plans
                    </div>
        						<div class="row plans_container">
        							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in oneTimePlans">
        								<div class="plan_box_inner">

        									<div class="row hd">
        										<div class="col-xl-9 col-lg-8 col-md-8 col-sm-8 sec_hd">
        			              	{{pricingPlan.name}}
        										</div>
        										<div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 price">
        											${{pricingPlan.price}}
        										</div>
        									</div>

        									<div class="row description_long">
        		              	<div class="col-12" v-html="pricingPlan.description"></div>
        									</div>

        									<div class="btn_container">
        		              	<a @click="selectFromPricingPlan(pricingPlan)" class="btn">Select</a>
        									</div>
        		            </div>
        							</div>

        							<div class="col-12" v-if="subscriptionPlans.length > 0">
        								Subscription Plans
        							</div>

        							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in subscriptionPlans">
        								<div class="plan_box_inner">

        									<div class="row hd">
        										<div class="col-xl-9 col-lg-8 col-md-8 col-sm-8 sec_hd">
        			              	{{pricingPlan.name}}
        										</div>
        										<div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 price">
        											${{pricingPlan.price}}
                              <span v-if="pricingPlan.type === 'subscription-monthly'">/month</span>
                              <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
                              <span v-if="pricingPlan.type === 'subscription-yearly'">/year</span>
        										</div>
        									</div>

        									<div class="row description_long">
        		              	<div class="col-12" v-html="pricingPlan.description"></div>
        									</div>

        									<div class="btn_container">
        		              	<a @click="selectFromPricingPlan(pricingPlan)" class="btn">Select</a>
        									</div>
        		            </div>
        							</div>

        						</div>

        					</div>
        				</div>

        			</b-modal>
        		</div>
        		<!-- Plan Detials Modal -->
            <program-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>

          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'programGuideMenu',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      alumniData: {},
      programGuide: {},
      showPage: false,
      showLoader: true,
      enrollmentStatus: 'NOTENROLLED',
      showPlansPage: true,
      showSummaryPage: false,
      showSuccessPage: false,
      selectedPricingPlan: {},
      stripe: undefined,
      elements: undefined,
      card: undefined,
      stripeCredentials: {},
      showStripeSetupError: false,
      billingFirstName: '',
      billingLastName: '',
      sameAsStudent: true,
      showMissingBillingInfoError: false,
      showPaymentFailureError: false,
      showPaymentLoader: false,
      coupon: '',
      couponObj: {},
      showCouponError: false,
      transactionValidity: {},
      userSISProgramMapping: {},
      paymentUrl: '',
      userPaymentMethods: [],
      selectedPaymentMethod: {
        uuid: ''
      }
    }
  },
  async beforeMount () {
    this.enrollmentStatus = this.userObj.enrollmentStatus
    this.alumniData = await this.loadProgramAlumniData(this.programGuideCode)
  },
  mounted () {
    this.loadProgramGuideInfo()
  },
  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadInstitutionPackage',
      'loadProgramAlumniData',
      'loadSaveEnrollmentStatus',
      'loadUserSubscriptions',
      'loadUpdateUserObj',
      'loadLearnerEnrollmentData',
      'loadGetInstitutionPaymentPublicCredentials',
      'loadPutCreatePaymentIntent',
      'loadPutFinalizePaymentIntent',
      'loadGetCheckValidityOfCoupon',
      'loadGetCouponCode',
      'loadCheckTransactionValidity',
      'loadUserSISProgramMapping',
      'loadCreateApplication',
      'loadResendApplicationLink',
      'loadPaymentLink',
      'loadUserPaymentMethods',
      'loadCreateUserPaymentMethod',
      'loadCreateSubscription',
      'loadLogDashboardActivity'
    ]),
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      if (!this.programGuide || !this.programGuide.cipCode) {
        return this.$router.push({name: this.returnTo})
      }
      await this.loadLearnerEnrollmentData(this.userObj.uuid)
      let status = 'NOTENROLLED'
    	this.learnerEnrollmentData.forEach(obj => {
      	if (obj.programCode === this.programGuide.code) {
        	status = obj.status
      	}
    	})
      this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
    	this.enrollmentStatus = status

      // If programGuide.paymentProcessedOutOfPragya is true, get userSISProgramMapping
      if (this.programGuide.paymentProcessedOutOfPragya) {
        this.userSISProgramMapping = await this.loadUserSISProgramMapping({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})

        if (Object.keys(this.userSISProgramMapping).length > 0) {
          if (this.userSISProgramMapping.status === 'ACCEPTED' && this.userSISProgramMapping.feeStatus === 'UNPAID') {
            this.paymentUrl = await this.loadPaymentLink({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
          }
        }
      }
      this.showLoader = false
      this.showPage = true
    },
    async createApplication () {
      if (!this.userSISProgramMapping) {
        this.showLoader = true
        this.userSISProgramMapping = await this.loadCreateApplication({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
        await this.$root.$emit('reloadLearnerDashboard')
        return this.$router.push({ name: 'learnerDashboard' })
        this.showLoader = false
      }
    },
    async resendApplicationLink () {
      this.showLoader = true
      await this.loadResendApplicationLink({sisProgramId:this.programGuide.sisProgramId, sisDegreeId:this.programGuide.sisDegreeId})
      this.showLoader = false
      this.$notify({
        group: 'notify',
        type: 'succes',
        title: '',
        text: 'Please check your email for application link'
      })
    },
    openPricePlanDetailsModal () {
			this.$refs.pricePlanDetailsModal.show()
		},
		closePricePlanDetailsModal () {
			this.$refs.pricePlanDetailsModal.hide()
		},
    selectFromPricingPlan (pricingPlan) {
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      this.selectedPricingPlan = pricingPlan
      this.showMissingBillingInfoError = false,
      this.showPaymentFailureError = false
      this.$refs.buyModal.show()
    },
    showBuyFlow () {
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      if (this.programGuide.pricingPlans.length > 0) {
        this.selectedPricingPlan = this.programGuide.pricingPlans[0]
      }
      this.showMissingBillingInfoError = false,
      this.showPaymentFailureError = false
      this.$refs.buyModal.show()
    },
    closeBuyModal () {
      if (this.card) {
        this.card.unmount()
        $('#card-element').removeClass('form-control')
      }
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
      this.$refs.buyModal.hide()
    },
    async moveToSummaryPage () {
      this.userPaymentMethods = await this.loadUserPaymentMethods()
      this.stripeCredentials = await this.loadGetInstitutionPaymentPublicCredentials(this.programGuide.institutionId)
      if (this.stripeCredentials) {
        if (this.selectedPricingPlan.type === 'onetime') {
          this.stripe = Stripe(this.stripeCredentials.publicKey, {
            stripeAccount: this.stripeCredentials.accountId
          })
        } else {
          this.stripe = Stripe(this.stripeCredentials.publicKey)
        }
        this.elements = this.stripe.elements()
        setTimeout(() => {
          this.card = this.elements.create('card')
          this.card.mount('#card-element')
          $('#card-element').addClass('form-control')
          this.showCardLoader = false
        }, 1000);
      } else {
        this.showStripeSetupError = true
      }
      if (this.billingLastName.length < 1) {
        this.billingLastName = this.lastName
      }

      if (this.billingFirstName.length < 1) {
        this.billingFirstName = this.firstName
      }
      this.showPlansPage = false
      this.showSummaryPage = true
      this.showSuccessPage = false
    },
    moveToPlansPage () {
      this.card.unmount()
      $('#card-element').removeClass('form-control')
      this.selectedPaymentMethod = {
        uuid: ''
      }
      this.showPlansPage = true
      this.showSummaryPage = false
      this.showSuccessPage = false
    },
    async moveToSuccessPage () {
      if (this.billingFirstName.length <= 0 || this.billingLastName.length <= 0) {
        this.showMissingBillingInfoError = true
      } else {
        if (this.selectedPricingPlan.type === 'subscription-monthly' || this.selectedPricingPlan.type === 'subscription-yearly' || this.selectedPricingPlan.type ==='subscription-monthly-payment-plan'){
          this.showPaymentLoader = true
          this.loadLogDashboardActivity({action: 'stripeInit', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

          // Create/Update Payment Method
          if (this.selectedPaymentMethod.uuid === '') {
            let result = await this.stripe.createPaymentMethod({
              type: 'card',
              card: this.card,
              billing_details: {
                name: this.billingFirstName + ' ' + this.billingFirstName,
                email: this.email
              }
            })
            if (result.error) {
              this.showPaymentFailureError = true
              this.showPaymentLoader = false
              return
            } else {
              let paymentMethodObj = {
                paymentMethodId: result.paymentMethod.id
              }
              this.selectedPaymentMethod = await this.loadCreateUserPaymentMethod(paymentMethodObj)
            }
          }

          // Create Subscription (we dont calculate final price here because Stripe will adjust using stripe coupon)
          let finalPrice = this.finalPrice
          let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

          let transactionObj = {
            entityId: this.programGuide.uuid,
            entityType: 'program',
            price: finalPrice,
            currency: this.selectedPricingPlan.currency,
            pricingPlanId: this.selectedPricingPlan.uuid,
            pricingPlanLearner: this.selectedPricingPlan,
            stripeProductId: this.selectedPricingPlan.stripeProductId,
            stripePriceId: this.selectedPricingPlan.stripePriceId,
            paymentMethodId: this.selectedPaymentMethod.uuid,
            type: 'firsttime',
            couponCodeId: couponId
          }

          let transactionResponse = await this.loadCreateSubscription(transactionObj)

          // Enroll user in program
          this.enrollmentStatus = 'INPROGRSS'
          let currentUserObj = this.userObj
          currentUserObj.enrollmentStatus = 'INPROGRSS'
          currentUserObj.major1 = this.programGuide.code
          await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
          await this.$root.$emit('reloadLearnerDashboard')
          this.showPaymentLoader = false
          this.card.unmount()
          $('#card-element').removeClass('form-control')
          this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)
          this.transactionValidityLoaded = true
          this.showPlansPage = false
          this.showSummaryPage = false
          this.showSuccessPage = true
          this.loadLogDashboardActivity({action: 'stripeSuccess', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})
          this.loadLogDashboardActivity({action: 'buyComplete', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

        } else {
          // One Time Transaction Starts
          this.showMissingBillingInfoError = false
          this.showPaymentLoader = true

          let finalPrice = this.finalPrice
          let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

          let transactionObj = {
            entityId: this.programGuide.uuid,
            entityType: 'program',
            price: finalPrice,
            currency: this.selectedPricingPlan.currency,
            pricingPlanId: this.selectedPricingPlan.uuid,
            pricingPlanLearner: this.selectedPricingPlan,
            type: 'firsttime',
            couponCodeId: couponId
          }
          let transactionResponse = await this.loadPutCreatePaymentIntent(transactionObj)
          if (finalPrice > 0) {
            let result = await this.stripe.confirmCardPayment(transactionResponse.paymentIntentObject, {
              payment_method: {
                card: this.card,
                billing_details: {
                  name: this.billingFirstName + ' ' + this.billingFirstName,
                  email: this.email
                }
              }
            })

            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              this.showPaymentFailureError = true
              this.showPaymentLoader = false
              this.loadLogDashboardActivity({action: 'stripeError', page: 'programSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'stripeError': result.error.code})
            } else {
              this.showPaymentFailureError = false
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                // call finalize Sale
                await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
                // Enroll user in program
                this.enrollmentStatus = 'INPROGRSS'
                let currentUserObj = this.userObj
                currentUserObj.enrollmentStatus = 'INPROGRSS'
                currentUserObj.major1 = this.programGuide.code
                await this.loadUpdateUserObj(currentUserObj)

              	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
              	await this.$root.$emit('reloadLearnerDashboard')
                this.showPaymentLoader = false
                this.card.unmount()
                $('#card-element').removeClass('form-control')

                // Check for transaction validity
                this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)

                this.showPlansPage = false
                this.showSummaryPage = false
                this.showSuccessPage = true
              }
            }
          } else {
            // call finalize Sale
            await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
            // Enroll user in program
            this.enrollmentStatus = 'INPROGRSS'
            let currentUserObj = this.userObj
            currentUserObj.enrollmentStatus = 'INPROGRSS'
            currentUserObj.major1 = this.programGuide.code
            await this.loadUpdateUserObj(currentUserObj)

            await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
            await this.$root.$emit('reloadLearnerDashboard')
            this.showPaymentLoader = false
            this.card.unmount()
            $('#card-element').removeClass('form-control')

            // Check for transaction validity
            this.transactionValidity = await this.loadCheckTransactionValidity(this.programGuide.code)

            this.showPlansPage = false
            this.showSummaryPage = false
            this.showSuccessPage = true
          }
          // One Time Transaction Ends
        }
      }
    },
    async applyCoupon () {
      this.showCouponError = false
      // check if the coupon is valid
      let responsValidity = await this.loadGetCheckValidityOfCoupon({couponCode: this.coupon, programCode: this.programGuide.code, pricingPlanId: this.selectedPricingPlan.uuid})
      if (responsValidity) {
        // if the coupon is valid get coupon information
        this.couponObj = await this.loadGetCouponCode(this.coupon)
      } else {
        this.showCouponError = true
      }
    },
    async removeCoupon () {
      this.coupon = ''
      this.couponObj = {}
    },
    async changeEnrollmentStatus () {
      let currentUserObj = this.userObj
      if('NOTENROLLED' === this.enrollmentStatus && 'NOTENROLLED' === currentUserObj.enrollmentStatus){
        return
      }
      if('NOTENROLLED' === this.enrollmentStatus){
        currentUserObj.major1 = undefined
      }else{
        currentUserObj.major1 = this.programGuide.code
      }
      currentUserObj.enrollmentStatus = this.enrollmentStatus
      await this.loadUpdateUserObj(currentUserObj)
      await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
      // this.$root.$emit('reloadLearnerDashboard')
    },
    subscribeToProgram () {
      return this.$router.push({ name: 'subscription' ,params: { programCode: this.programGuide.code } })
    },
    async confirmProgramSubscription () {

      let currentUserObj = this.userObj
      currentUserObj.enrollmentStatus = 'INPROGRSS'
      currentUserObj.major1 = this.programGuide.code
      await this.loadUpdateUserObj(currentUserObj)

      this.enrollmentStatus = 'INPROGRSS'
    	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
    	// await this.$root.$emit('reloadLearnerDashboard')
      return this.$router.push({ name: 'learnerDashboard' })
    },
    redirectToLearnerDashboard () {
      return this.$router.push({ name: 'learnerDashboard' })
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getModalityValue(key){
        let arr = [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    formatNumericVal (numValue) {
      return parseFloat(numValue).toFixed(1)
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    navigateToCareerProspects () {
      return this.$router.push({name: 'programGuideCareerProspects', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToCareers () {
      return this.$router.push({name: 'programGuideCareers', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToPathways () {
      return this.$router.push({name: 'programGuidePathways', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToAlumniInsights () {
      return this.$router.push({name: 'programGuideAlumniInsights', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToRequirements () {
      return this.$router.push({name: 'programGuideRequirements', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToIntro () {
      return this.$router.push({name: 'programGuideAbout', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToConcentrations () {
      return this.$router.push({name: 'programGuideConcentrations', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToRelatedPrograms () {
      return this.$router.push({name: 'programGuideRelatedPrograms', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToFAQView () {
      return this.$router.push({ name: 'programGuideFAQ', params: this.programGuideParams, query: this.programGuideQuery })
    },
    navigateToComplianceView () {
      return this.$router.push({ name: 'programGuideCompliance', params: this.programGuideParams, query: this.programGuideQuery })
    },
    navigateToMyProgramStatus () {
      return this.$router.push({name: 'programGuideMyProgramStatus', params: this.programGuideParams, query: this.programGuideQuery})
    },
    navigateToSpotlightAlumniView () {
      return this.$router.push({name: 'programGuideSpotlightAlumni', params: this.programGuideParams, query: this.programGuideQuery})
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages,
      'institution': state => state.dashboard.institution,
      'learnerDashboardState': state => state.dashboard.learnerDashboardState,
      'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
    }),
    oneTimePlans () {
      let plans = []
      if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.type === 'onetime') {
            plans.push(item)
          }
        })
      }
      return plans
    },
    subscriptionPlans () {
      let plans = []
      if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.type !== 'onetime') {
            plans.push(item)
          }
        })
      }
      return plans
    },
    hasAValidSubscription () {
      if (this.userSubscriptions.length > 0) {
        return true
      }
      return false
    },
    enrollmentEnabled () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.allowEnrollment) {
        return false
      }
      return exploreProgramDetailFlagMap.allowEnrollment.enabled
    },
    multipleEnrollmentEnabled () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.allowMultipleEnrollment) {
        return false
      }
      return exploreProgramDetailFlagMap.allowMultipleEnrollment.enabled
    },
    showEnrollment () {
      let userObj = this.userObj
      if(this.enrollmentEnabled && userObj.roles[0].role === 'Student'){
	    	if(this.multipleEnrollmentEnabled){
	    			return true
	    	}
      	let showFlag = false
      	if(!this.learnerEnrollmentData || this.learnerEnrollmentData.length==0){
      			showFlag = true
      	} else {
      		this.learnerEnrollmentData.forEach(obj => {
        		if (obj.programCode === this.programGuide.code) {
          		showFlag = true
        		}
      		})
      	}
      	return showFlag;
      }else{
      		return false
      }
    },
    returnTo () {
      if (this.isComingFromBookmark) {
        return this.$route.query.returnTo || 'bookmarks'
      }
      return this.$route.query.returnTo || 'exploreProgramResults'
    },
    pageTitle () {
      if (this.isComingFromBookmark) {
        return this.$route.query.pageTitle || 'Back To Bookmarks'
      }
      return this.$route.query.pageTitle || 'Back To Results'
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    programGuideParams () {
      let params = {
        code: this.code,
        cipCode: this.programGuide.cipCode,
        programGuideCode: this.programGuide.code,
        type: this.programGuide.type,
        isComingFromBookmark: this.isComingFromBookmark
      }
      return params
    },
    programGuideQuery () {
      if (this.isComingFromBookmark) {
        return {returnTo: this.returnTo, pageTitle: this.pageTitle}
      }
      return {}
    },
    showIntroductionTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.introductionTab) {
        return false
      }
      return exploreProgramDetailFlagMap.introductionTab.enabled
    },
    introductionTabLabel () {
      const defaultLabel = 'Introduction'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.introduction){
          return this.programGuide.tabLabelMap.introduction
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.introductionTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.introductionTab.label || defaultLabel
    },
    showCareerProspectsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careerProspectsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.careerProspectsTab.enabled
    },
    careerProspectsTabLabel () {
      const defaultLabel = 'Career Prospects'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.careerProspects){
          return this.programGuide.tabLabelMap.careerProspects
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careerProspectsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.careerProspectsTab.label || defaultLabel
    },
    showDegreeRequirementsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.degreeRequirementsTab) {
        return false
      }
      if (exploreProgramDetailFlagMap && exploreProgramDetailFlagMap.hideRequirementWithProgress && exploreProgramDetailFlagMap.hideRequirementWithProgress.enabled) {
        return !this.showMyProgramStatusTab
      }
      if(exploreProgramDetailFlagMap.degreeRequirementsTab.enabled){
        let programGuide = this.programGuide
        let haveCourses = (programGuide.categories && programGuide.categories.length >0)
        let haveCocur = (programGuide.cocurricularRequirement && programGuide.cocurricularRequirement.length >0)
        let haveEducations = (programGuide.educationRequirement && programGuide.educationRequirement.length >0)
        if(haveCourses || haveCocur || haveEducations) {
          return true
        }
      }
      return false
    },
    showConcentrationTab () {
      if (this.programGuide.concentrations && this.programGuide.concentrations.length > 0) {
        return true
      }
      return false
    },
    degreeRequirementsTabLabel () {
      const defaultLabel = 'Requirements'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.requirements){
          return this.programGuide.tabLabelMap.requirements
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.degreeRequirementsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.degreeRequirementsTab.label || defaultLabel
    },
    showStreamsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.streamsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.streamsTab.enabled
    },
    streamsTabLabel () {
      const defaultLabel = 'Pathways'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.pathways){
          return this.programGuide.tabLabelMap.pathways
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.streamsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.streamsTab.label || defaultLabel
    },
    showCareersTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careersTab) {
        return false
      }
      return exploreProgramDetailFlagMap.careersTab.enabled
    },
    careersTabLabel () {
      const defaultLabel = 'Careers'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careersTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.careersTab.label || defaultLabel
    },
    showAlumniInsightsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.alumniInsightsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.alumniInsightsTab.enabled
    },
    showMyProgramStatusTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showProgramProgress) {
        return false
      }
      return exploreProgramDetailFlagMap.showProgramProgress.enabled && this.learnerDashboardState.enrollInProgram && this.isCurrentEnrolledProgram
    },
    showAlumniTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    showAlumniDataJobTitle () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && this.alumniData.topCareerTitle && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    isCurrentEnrolledProgram () {
      let currentProgram = false
      for (let i = 0; i < this.learnerEnrollmentData.length; i++) {
        let data = this.learnerEnrollmentData[i]
        if (data.programCode === this.programGuide.code) {
          currentProgram = true
          break
        }
      }
      return currentProgram
    },
    alumniInsightsTabLabel () {
      const defaultLabel = 'Alumni Insights'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.alumniInsightsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.alumniInsightsTab.label || defaultLabel
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },
    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },
    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },
    showRelatedProgramTab () {
      if (this.programGuide.relatedPrograms && this.programGuide.relatedPrograms.length >0 ) {
        return true
      }
      return false
    },
    showFAQTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.faqTab) {
        return false
      }

      if (exploreProgramDetailFlagMap.faqTab.enabled) {
        let programGuide = this.programGuideObject
        if (this.programGuide.faqGroup && this.programGuide.faqGroup.faqGroups && this.programGuide.faqGroup.faqGroups.length > 0) {
          return true
        }
      }
      return false
    },
    FAQTabLabel () {
      const defaultLabel = 'FAQ'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.faqLabel){
          return this.programGuide.tabLabelMap.faqLabel
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.faqTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.faqTab.label || defaultLabel
    },
    showComplianceTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.institutionSpecificInfo) {
        return false
      }

      if (exploreProgramDetailFlagMap.institutionSpecificInfo.enabled) {
        let programGuide = this.programGuideObject

        if (this.programGuide.institutionSpecificInfo && this.programGuide.institutionSpecificInfo.subGroups && this.programGuide.institutionSpecificInfo.subGroups.length > 0) {
          return true
        }
      }
      return false
    },
    complianceTabLabel () {
      const defaultLabel = 'Institution Info'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.institutionSpecificInfoLabel){
          return this.programGuide.tabLabelMap.institutionSpecificInfoLabel
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.institutionSpecificInfo) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.institutionSpecificInfo.label || defaultLabel
    },
    relatedProgramsTabLabel () {
      const defaultLabel = 'Related Programs'
      if(this.programGuide.tabLabelMap && this.programGuide.tabLabelMap.relatedPrograms){
          return this.programGuide.tabLabelMap.relatedPrograms
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.relatedProgramsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.relatedProgramsTab.label || defaultLabel
    },
    firstName () {
      let currentUserObj = this.userObj
      return currentUserObj.firstName
    },
    lastName () {
      let currentUserObj = this.userObj
      return currentUserObj.lastName
    },
    email () {
      let currentUserObj = this.userObj
      return currentUserObj.eMail
    },
    currencyLabel () {
      return '$'
    },
    minPrice () {
      let minPrice = 0
      if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
        minPrice = this.programGuide.pricingPlans[0].price
        this.programGuide.pricingPlans.forEach((item, i) => {
          if (item.price < minPrice) {
            minPrice = item.price
          }
        })
      }
      if (minPrice === 0) {
        return 'Free'
      }
      return '$' + minPrice
    },
    isPricingAvailable () {
      if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
        return true
      }
    },
    finalPrice () {

      if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
        let price = this.selectedPricingPlan.price
        if (this.couponObj.type === 'flat') {
          price = price - this.couponObj.value
          if (price < 0) {
            price = 0
          }
          price = price.toFixed(2)
        } else  if (this.couponObj.type === 'percentage') {
          let discount = (price * this.couponObj.value) / 100
          discount = discount.toFixed(2)
          price = price - discount
          if (price < 0) {
            price = 0
          }
          price = price.toFixed(2)
        }
        return price
      }

      if (this.selectedPricingPlan) {
        return this.selectedPricingPlan.price
      }
    },
    discountPrice () {
      if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
        let price = this.selectedPricingPlan.price
        if (this.couponObj.type === 'flat') {
          return this.couponObj.value
        } else  if (this.couponObj.type === 'percentage') {
          let discount = (price * this.couponObj.value) / 100
          return discount.toFixed(2)
        }
      }

      return 0
    },
    paymentMethodsToShow () {
      let methods = []
      this.userPaymentMethods.forEach((item, i) => {
        let details = JSON.parse(item.stripePaymentMethod)
        item.expiration = details.card.exp_month + '/' + details.card.exp_year
        item.brand = details.card.brand
        methods.push(item)
      })
      return methods
    }
  },

  watch: {
    sameAsStudent (newSameAsStudent) {
      if (!newSameAsStudent) {
        this.billingFirstName = ''
        this.billingLastName = ''
      } else {
        this.billingFirstName = this.firstName
        this.billingLastName = this.lastName
      }
    }
  },
}
</script>

<style>
.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideMenu.vue